$(document).ready(function () {

    $('body').css('display', 'block'); 

    // Smooth page transition when a link is clicked
    $('a').click(function (event) {
        event.preventDefault();
        var newLocation = this.href;

        $('body').fadeOut(10, function () {
           setTimeout(function() {
                window.location = newLocation;
            }, 01);
        });
    });
});

$(window).on('load', function () {
    $('body').css('display', 'block');
});